(function($, window, document) { // jQuery wrapper

    // Page Functions
    window.PageFunctions = {
        /**
         *  Init WOW.js
         *  @link https://github.com/matthieua/WOW
         */
        initWOW: function() {
            var wow = new WOW(
              {
                boxClass:     'animate',    // animated element css class (default is wow)
                animateClass: 'animated',   // animation css class (default is animated)
                offset:       150,          // distance to the element when triggering the animation (default is 0)
              }
            );
            wow.init();
        },

        /**
         * Mobile Menu functionality
         */
        mobileMenu: function() {
          $(".menu-trigger-container").on("click", function(e) {
              e.preventDefault();
              if ($('body').hasClass("menu-open")) {
                  $('body').removeClass("menu-open");
              } else {
                  $('body').addClass("menu-open");
              }
          });
        },

        /**
         * Scroll to anchor links
         */
        scrollToAnchorLinks: function() {
          $(".wrap a[href^='#']").on("click", function(e) {
              e.preventDefault();
              href = $(this).attr("href");

              if (href.length > 1) {
                  $("html, body").animate(
                      {
                          scrollTop: $(href).offset().top - 165
                      },
                      500
                  );
              }
          });
        },

        /**
         *  Add shrink class to header on scroll
         */
        shrinkHeaderOnScroll: function() {
            var $threshold = 20,
                $window = $(window),
                $height = $window.scrollTop();

            $window.scroll(function() {
                $scroll_position = $window.scrollTop();
                if ($scroll_position > $threshold) {
                    $("body").addClass("shrink");
                } else {
                    $("body").removeClass("shrink");
                }
            });

            // if the scroll position is greater than 0, add the shrink class. This handles a refresh in the middle of the page.
            if ($height > 0) {
                $("body").addClass("shrink");
            }
        },
        /**
         * Initialize FitVids
         * @link https://github.com/davatron5000/FitVids.js
         */
        initFitVids: function() {
          $(document).ready(function(){
            $("body").fitVids();
          });
        },

        /**
         * Extracts the filename from a string
         */
         extractFileName: function($str) {
            return $str.substring($str.lastIndexOf('/')+1);
         },

        /**
         * Apply "current menu item" class to navigation
         */
        currentMenuItem: function() {

          var $currentFile = window.location.pathname;

          $("body.static #sidebar ul li a, body.static ul.main-navigation li a").each(function() {
            
              $menuHref = $(this).attr('href');
              $menuFile = window.PageFunctions.extractFileName($menuHref);
              $currentUrl = window.PageFunctions.extractFileName( $currentFile );
              
              if ($menuFile === $currentUrl) {
                $(this).addClass('current-page');
              }

          });

        },

        /**
         * Load more comments ajax
         */
        
        loadMoreComments: function() {
              
               
                // load more button click event
                $('.exits_comment_loadmore').click( function(){
                  var button = $(this);
               
                  // decrease the current comment page value
                  cpage--;
               
                  $.ajax({
                    url : ajaxurl, // AJAX handler, declared before
                    data : {
                      'action': 'cloadmore', // wp_ajax_cloadmore
                      'post_id': parent_post_id, // the current post
                      'cpage' : cpage, // current comment page
                    },
                    type : 'POST',
                    beforeSend : function ( xhr ) {
                      button.text('Loading...'); // preloader here
                    },
                    success : function( data ){

                      if( data ) {
                        $('ol.comment-list').append( data );
                        button.text('Load More'); 
                         // if the last page, remove the button
                        if ( cpage == 1 )
                          button.remove();
                      } else {
                        button.remove();
                      }
                    }
                  });
                  return false;
                });
               
              
        }
       

    };

}(window.jQuery, window, document)); // End of jQuery wrapper